import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants/constants';
import { narrativeGenerators } from 'src/hooks/api/userActions/helper';
import { IAssembly } from 'src/interfaces';
import { IStatus } from 'src/interfaces';
import { queryKeys } from 'src/utils';

import { requestCCApi } from '../../../utils/axios-utils';

export const useCreateAssembly = () => {
  return useMutation({
    mutationFn: createAssembly,
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      await queryClient.invalidateQueries(
        queryKeys.assemblyListing.invalidateAll(),
      );
      await queryClient.invalidateQueries(
        queryKeys.assemblyTags.invalidateAll(),
      );
      await queryClient.invalidateQueries(
        queryKeys.viewAssemblyTagsWithAssembliesCount.invalidateAll(),
      );
      await queryClient.invalidateQueries(
        queryKeys.bulkReplaceEligibleAssemblyIds.invalidateAll(),
      );
      await queryClient.invalidateQueries(
        queryKeys.scheduleAssembliesSearch.invalidateAll(),
      );
    },
  });
};

const createAssembly = async (payload: Partial<IAssembly>) => {
  const request = {
    name: payload.name,
    layout_id: payload.layout_id,
    assembly_tag_id: payload.assembly_tag_id,
    status: IStatus.DRAFT,
    ...(payload.name && {
      narrative: (
        narrativeGenerators[COLLECTIONS.ASSEMBLIES][USER_ACTIONS.CREATE] as (
          assemblyName: string,
        ) => string
      )(payload.name),
    }),
  };

  const response = await requestCCApi({
    url: `/assemblies`,
    method: 'POST',
    data: { data: request },
  });

  return response;
};
